const INVITATION_PATH = '/invitations/custom/carlo-and-cristina-wedding';

if (window.location.pathname.includes(INVITATION_PATH)) {
  const STYLE_ID = 'cc-venue-same-place-note-styles';

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .cc-venue-same-place-note {
        position: relative;
        z-index: 1;
        display: block;
        width: min(calc(100% - 24px), 520px);
        max-width: 100%;
        margin: 16px auto 18px;
        padding: 9px 16px;
        border: 1px solid rgba(231, 210, 160, .34);
        border-radius: 999px;
        background: rgba(251, 243, 228, .10);
        color: #f3ead9;
        font-size: clamp(12px, 1.8vw, 14px);
        font-weight: 600;
        line-height: 1.4;
        text-align: center;
        overflow-wrap: anywhere;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, .08);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
      }

      .cc-venue-same-place-note strong {
        color: #e7d2a0;
        font-weight: 700;
      }

      .cc-venue-same-place-note + .cc-map-actions {
        position: relative;
        z-index: 1;
        margin-top: 0;
      }

      @media (max-width: 640px) {
        .cc-venue-same-place-note {
          width: min(calc(100% - 12px), 460px);
          margin: 14px auto 16px;
          padding: 9px 12px;
          border-radius: 14px;
          font-size: 12px;
          line-height: 1.38;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const ensureVenueNote = () => {
    const venueSection = document.getElementById('cc-venue');
    if (!venueSection) return false;
    if (venueSection.querySelector('.cc-venue-same-place-note')) return true;

    const venueDateTime = venueSection.querySelector('.cc-venue-datetime');
    const mapActions = venueSection.querySelector('.cc-map-actions');
    if (!venueDateTime) return false;

    const note = document.createElement('p');
    note.className = 'cc-venue-same-place-note';
    note.setAttribute('role', 'note');
    note.innerHTML = '<strong>Please note:</strong> The wedding ceremony and reception will be held at the same venue.';

    if (mapActions) mapActions.before(note);
    else venueDateTime.after(note);

    return true;
  };

  const ensureHeroCopy = () => {
    const kicker = document.querySelector('.cc-hero-kicker');
    const tagline = document.querySelector('.cc-hero-tagline');
    if (!kicker || !tagline) return false;

    const kickerCopy = "You're invited to celebrate the wedding of";
    const taglineCopy = 'as they tie the knot.';

    if (kicker.textContent !== kickerCopy) kicker.textContent = kickerCopy;
    if (tagline.textContent !== taglineCopy) tagline.textContent = taglineCopy;
    return true;
  };

  const ensureBridesmaidName = () => {
    const weddingParty = document.getElementById('cc-party');
    if (!weddingParty) return false;

    const nameItem = Array.from(weddingParty.querySelectorAll('li'))
      .find((item) => ['Rizza Robrigado', 'Rizza Mae Robrigado'].includes(item.textContent.trim()));
    if (!nameItem) return false;

    if (nameItem.textContent.trim() !== 'Rizza Mae Robrigado') {
      nameItem.textContent = 'Rizza Mae Robrigado';
    }
    return true;
  };

  const ensureTimelineCopy = () => {
    const timeline = document.getElementById('cc-timeline');
    if (!timeline) return false;

    const sixPmItem = Array.from(timeline.querySelectorAll('.cc-timeline-item'))
      .find((item) => item.querySelector('.cc-timeline-time')?.textContent.trim() === '6:00 PM');
    const title = sixPmItem?.querySelector('.cc-timeline-title');
    if (!title) return false;

    if (title.textContent.trim() !== 'Reception Program') {
      title.textContent = 'Reception Program';
    }
    return true;
  };

  const syncInvitationRevisions = () => {
    ensureVenueNote();
    ensureHeroCopy();
    ensureBridesmaidName();
    ensureTimelineCopy();
  };

  ensureStyles();
  syncInvitationRevisions();

  const root = document.getElementById('root') || document.body;
  let syncScheduled = false;

  const scheduleSync = () => {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(() => {
      syncScheduled = false;
      syncInvitationRevisions();
    });
  };

  const observer = new MutationObserver(scheduleSync);
  observer.observe(root, { childList: true, subtree: true });
}
